import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CustomersContainer from './container';
import { useGetCustomersListQuery } from './services';
import { formatCurrency } from 'utils/function';
import { Avatar, Box } from '@mui/material';

const Customers = () => {
  const vendorData = useSelector((state) => state?.posData);
  const vendorDataId = vendorData?.vendor_id ? vendorData?.vendor_id : vendorData?.id;

  const [searchQuery, setSearchQuery] = useState('');
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10
  });

  const { data: resp, isLoading, isError } = useGetCustomersListQuery({
    page: paginationModel.page + 1,        // assuming backend pages are 1-based
    limit: paginationModel.pageSize,
    search: searchQuery,
    vendor_id: vendorDataId,
  });

  // pull out records / total count safely
  const records = resp?.data?.records || [];
  const totalCount = resp?.data?.totalCount || 0;

  // column definitions for CommonTable
  const columns = [
    {
      headerName: 'Customer Name',
      field: 'customer_full_name',
      flex: 1,
      minWidth: 150,
      maxWidth: 300,
      renderCell: ({ row }) => (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            height: '100%',
            paddingLeft: "10px",
          }}
        >
          <Avatar
            sx={{
              width: 32,
              height: 32,
              bgcolor: '#000',
              color: '#fff',
              fontSize: '14px',
              fontWeight: 600,
            }}
          >
            {row?.full_name?.charAt(0)?.toUpperCase() || 'N'}
          </Avatar>

          <Box>
            {row?.full_name || 'N/A'}
          </Box>
        </Box>
      ),
    },
    {
      headerName: 'Phone Number',
      field: 'phone',
      flex: 1,
      minWidth: 150,
      maxWidth: 300,
      // renderCell: ({ row }) => `${row?.country_code} ${row?.phone}` || 'N/A',
      renderCell: ({ row }) =>
        <Box sx={{ paddingLeft: "10px" }}>
          {`${row?.country_code} ${row?.phone}` || 'N/A'}
        </Box>
    },
    {
      headerName: 'Total Orders',
      field: 'totalOrders',
      flex: 1,
      minWidth: 150,
      maxWidth: 300,
      // renderCell: ({ row }) => `${row?.totalOrders}` || '0',
      renderCell: ({ row }) =>
        <Box sx={{ paddingLeft: "10px" }}>
          {`${row?.totalOrders}` || '0'}
        </Box>
    },
    {
      headerName: 'Total Revenue',
      field: 'totalRevenue',
      flex: 1,
      minWidth: 150,
      maxWidth: 300,
      // renderCell: ({ row }) =>
      //   formatCurrency(row?.totalRevenue || 0, vendorData?.vendor?.currency),
      renderCell: ({ row }) =>
        <Box sx={{ paddingLeft: "10px" }}>
          {formatCurrency(row?.totalRevenue || 0, vendorData?.vendor?.currency)}
        </Box>
    },
  ];


  return (
    <CustomersContainer
      columns={columns}
      rows={records}
      totalCount={totalCount}
      loading={isLoading}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      paginationModel={paginationModel}
      setPaginationModel={setPaginationModel}
      error={isError}
    />
  );
};

export default Customers;
